var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCoverage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 1.874A1.874 1.874 0 0057.758.037L39.374 3.712 20.992.037a1.875 1.875 0 00-.735 0l-18.75 3.75A1.875 1.875 0 000 5.624v52.5a1.875 1.875 0 002.243 1.838l18.382-3.675 18.383 3.675c.242.048.492.048.734 0l18.75-3.75A1.875 1.875 0 0060 54.374v-52.5zM18.75 52.837V4.162l1.875-.375 1.875.375v48.675l-1.508-.3a1.867 1.867 0 00-.735 0l-1.507.3zm18.75 3V7.162l1.508.3c.242.048.492.048.734 0l1.508-.3v48.675l-1.875.375-1.875-.375z",
    fill: "#8098B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverage);
export default __webpack_public_path__ + "static/media/coverage.ef786d6ac672111f7c5852a6fbd9529b.svg";
export { ForwardRef as ReactComponent };